import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_WEBINAR_DATA, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    getWebinarsRssFeedData:
        (userType: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (state && state?.webinarsState && state?.webinarsState?.webinarsData != null && state?.webinarsState?.webinarsData?.length < 1) {
                dispatch({ type: SHOW_LOADER, isLoading: true });
                services
                    .getRSSFeed("1", userType + "-resources", "webinars")
                    .then((data) => {
                        dispatch({ type: RECEIVE_WEBINAR_DATA, webinarsData: data });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
